import {useQuery} from "@tanstack/vue-query";

export const getKitSettings = () => useQuery({
  queryKey: ['kit-settings'],
  queryFn: async () => {
    const {data} = await axios.get('/ajax/v2/seo-agent-settings');

    return data.data;
  }
});
